
<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar-publicos-alvo" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="!isVisualizacao">Cadastrar público alvo</h5>
      <h5 class="modal-title" v-else>Visualizar público alvo</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar-publicos-alvo')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <fieldset :disabled="isVisualizacao">
      <div class="row">
        <div class="col-12">
          <form-group id="tituloPublicoAlvo" label="Título *" :text="{ required: 'Obrigatório informar o título' }" :field="$v.publicoAlvo.titulo">
            <input type="text" class="form-control" id="titulo" v-model="publicoAlvo.titulo"/>
          </form-group>
        </div>
        <div class="col-12">
          <form-group id="DescPublicoAlvo" label="Descrição *" :field="$v.publicoAlvo.descricao">
            <textarea class="form-control" id="descricao" v-model="publicoAlvo.descricao"></textarea>
          </form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Plano Pro</label>
            <select class="form-control" v-model="publicoAlvo.filtro.plano_macro_id_pro">
              <option value="">Todos</option>
              <option v-for="plano in this.planoPro" :value="plano.id" v-bind:key="plano.id">{{plano.nome}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Recorrencia plano pró</label>
            <select class="form-control" v-model="publicoAlvo.filtro.duracao_id_pro">
              <option value="">Todos</option>
              <option v-for="duracao in publicoAlvo.duracoes" :value="duracao.id" v-bind:key="duracao.id">{{duracao.nome}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <!-- <div class="form-group">
            <label>Ciclo do estudante</label>
            <select class="form-control">
              <option value="">Todos</option>
            </select>
          </div> -->
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Plano Adicional</label>
            <select class="form-control" v-model="publicoAlvo.filtro.plano_macro_id_adicional">
              <option value="">Todos</option>
              <option v-for="plano in this.planoAdicional" :value="plano.id" v-bind:key="plano.id">{{plano.nome}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Recorrencia plano adicional</label>
            <select class="form-control" v-model="publicoAlvo.filtro.duracao_id_adicional">
              <option value="">Todos</option>
              <option v-for="duracao in publicoAlvo.duracoes" :value="duracao.id" v-bind:key="duracao.id">{{duracao.nome}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Tipo de assinatura</label>
            <select class="form-control" v-model="publicoAlvo.filtro.tipo_assinatura_id">
              <option v-for="tipo in publicoAlvo.tipos_assinaturas" :value="tipo.id" v-bind:key="tipo.id">{{tipo.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>Status da Assinatura</label>
            <select class="form-control" v-model="publicoAlvo.filtro.status_assinatura_id">
              <option value="">Todos</option>
              <option v-for="tipo in publicoAlvo.tipos_status" :value="tipo.id" v-bind:key="tipo.id">{{tipo.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <!-- <div class="form-group">
            <label> Renovação cancelada</label>
            <input type="checkbox" v-model="publicoAlvo.filtro.renovacaoCancelada">
          </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label><input type="checkbox" v-model="publicoAlvo.filtro.assinatura_date" /> Filtrar por data de assinatura</label>
            <date-range-picker
              v-if="publicoAlvo.filtro.assinatura_date"
              ref="picker"
              :auto-apply="true"
              opens="center"
              v-model="publicoAlvo.filtro.assinatura_date_range"
              :locale-data="dateRangeLocale"
              :ranges="filtrosDateRangePredefinidos">
            </date-range-picker>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label><input type="checkbox" v-model="publicoAlvo.filtro.cancelamento_date" /> Filtrar por data de cancelamento</label>
            <date-range-picker
              v-if="publicoAlvo.filtro.cancelamento_date"
              ref="picker"
              :auto-apply="true"
              opens="center"
              v-model="publicoAlvo.filtro.cancelamento_date_range"
              :locale-data="dateRangeLocale"
              :ranges="filtrosDateRangePredefinidos">
            </date-range-picker>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <!-- <div class="form-group">
            <label><input type="checkbox" v-model="publicoAlvo.filtro.renovacao_date" /> Filtrar por data de renovação</label>
            <date-range-picker
              v-if="publicoAlvo.filtro.renovacao_date"
              ref="picker"
              :auto-apply="true"
              opens="center"
              v-model="publicoAlvo.filtro.renovacao_date_range"
              :locale-data="dateRangeLocale"
              :ranges="filtrosDateRangePredefinidos">
            </date-range-picker>
          </div> -->
        </div>
      </div>
      </fieldset>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" v-if="!isVisualizacao" @click="cadastrarPublicoAlvo">Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar-publicos-alvo')" v-if="isVisualizacao">Fechar</a>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar-publicos-alvo')" v-else >Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'
import PublicoAlvoAPI from '@/api/publico-alvo-api'
import CortesiaAPI from '@/api/cortesia-api'
import AssinaturaAPI from '@/api/assinatura-api'
import DateUtils from '@/core/util/date-utils'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'ModalCadastroPublicoAlvo',
  components: {
    DateRangePicker,
    FormGroup
  },

  props: {
    publicoAlvoEdicao: Object
  },

  data () {
    return {
      publicoAlvo: {
        titulo: '',
        descricao: '',
        filtro: {
          plano_macro_id_pro: '3',
          plano_macro_id_adicional: '35',
          duracao_id_pro: '',
          duracao_id_adicional: '',
          ciclo_estudante: '',
          tipo_pagamento_id: '',
          status_assinatura_id: '2',
          tipo_assinatura_id: '4',
          renovacao_cancelada: false,
          assinatura_date: false,
          cancelamento_date: false,
          renovacao_date: false,
          assinatura_date_range: {
            startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
            endDate: DateUtils.formatDate(DateUtils.create().add(1, 'month').toDate())
          },
          cancelamento_date_range: {
            startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
            endDate: DateUtils.formatDate(DateUtils.create().add(1, 'month').toDate())
          },
          renovacao_date_range: {
            startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
            endDate: DateUtils.formatDate(DateUtils.create().add(1, 'month').toDate())
          }
        },
        pagina: 1,
        planos: [],
        tipos_planos: [],
        tipos_status: [],
        tipos_assinaturas: [],
        quantidade: 0,
        infiniteId: new Date(),
        scrolled: false,
        duracoes: [
          { 'id': 1, 'nome': 'Mensal' },
          { 'id': 3, 'nome': 'Trimestral' },
          { 'id': 6, 'nome': 'Semestral' },
          { 'id': 12, 'nome': 'Anual' }
        ]
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.publicoAlvoEdicao) {
        this.publicoAlvo = Object.assign({}, this.publicoAlvoEdicao)
      } else {
        CortesiaAPI.listarPlanos().then(data => {
          this.publicoAlvo.planos = data
        })

        AssinaturaAPI.listarStatus().then(data => {
          this.publicoAlvo.tipos_status = data
        })

        AssinaturaAPI.listarTipos().then(data => {
          this.publicoAlvo.tipos_assinaturas = data
        })
      }
    })
  },

  computed: {
    isVisualizacao: function () {
      return this.publicoAlvoEdicao
    },
    planoPro: function () {
      return this.publicoAlvo.planos.filter(function (item) {
        return item.planos[0].tipo_plano_id === 1
      })
    },
    planoAdicional: function () {
      return this.publicoAlvo.planos.filter(function (item) {
        return item.planos[0].tipo_plano_id === 2
      })
    }
  },

  validations: {
    publicoAlvo: {
      titulo: { required },
      descricao: { required },
      filtro: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar-publicos-alvo')
    },

    cadastrarPublicoAlvo: function () {
      this.$v.publicoAlvo.$touch()
      if (!this.$v.publicoAlvo.$invalid) {
        const loader = this.$loading.show()

        PublicoAlvoAPI.salvar(this.publicoAlvo).then(data => {
          loader.hide()
          console.log('data', data)
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Público Alvo criado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar-publicos-alvo')
            this.$emit('publicoAlvoSalva', this.publicoAlvo)
          })
        }).catch(error => {
          ResponseUtils.handleError(error, loader)
        })
      }
    }
  }
}

</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
